import React from "react";
import { Link } from "react-router-dom";
import MetaData from "../components/layout/MetaData";
import { Image } from "react-bootstrap"; // Consider replacing this with a native img tag if you want full TailwindCSS integration

export default function NotFound() {
  return (
    <>
      <MetaData title="Page Not Found" />
      <main className="flex items-center justify-center h-screen bg-gray-100">
        <div className="text-center p-4 shadow-lg rounded-lg bg-white max-w-lg">
          <h1 className="text-4xl font-bold text-gray-800">Oops!</h1>
          <p className="mt-4">
            We can't seem to find the page you're looking for.
            <br />
            Try going back to the previous page or see our
            <Link
              to="/products"
              className="text-blue-500 hover:text-blue-700 underline ml-1"
            >
              FAQ
            </Link>{" "}
            section for more information.
          </p>
          <Link
            to="/"
            className="mt-6 inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
          >
            Back to Home
          </Link>
          <div className="mt-6">
            <Image
              src="/img/error_404.png"
              alt="404 Not Found"
              className="mx-auto"
            />
          </div>
        </div>
      </main>
    </>
  );
}
